"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _borderRadius = require("@r1-frontend/ui-react/tokens/borderRadius");

var _colors = require("@r1-frontend/ui-react/tokens/colors");

var themes = {
  bordered: {
    background: _colors.COLORS.BgMain,
    borderWidth: '1px',
    radius: '4px',
    padding: '20px',
    mobilePadding: '15px',
    color: _colors.COLORS.TextPrimary
  },
  simple: {
    background: 'transparent',
    borderWidth: '1px 0',
    radius: '0px',
    padding: '20px 0',
    mobilePadding: '15px 0',
    color: _colors.COLORS.TextPrimary
  },
  light: {
    border: _colors.COLORS.BgLight,
    background: _colors.COLORS.BgLight,
    color: _colors.COLORS.TextPrimary,
    colorArrow: _colors.COLORS.GRAY_DARK,
    backgroundIcon: _colors.COLORS.BgSecondary,
    borderIcon: _colors.COLORS.BgSecondary,
    colorArrowIsOpen: _colors.COLORS.GRAY_DARK,
    backgroundIconIsOpen: _colors.COLORS.Outline_Light,
    borderIconIsOpen: _colors.COLORS.Outline_Light,
    radius: _borderRadius.BorderRadius.componentRadius,
    padding: '20px 24px',
    mobilePadding: '15px',
    storyColor: _colors.COLORS.BgMain
  },
  dark: {
    border: _colors.COLORS.Control,
    background: _colors.COLORS.Control,
    color: _colors.COLORS.TextWhite,
    colorArrow: _colors.COLORS.Control,
    backgroundIcon: _colors.COLORS.GRAY_DARK,
    borderIcon: _colors.COLORS.GRAY_DARK,
    colorArrowIsOpen: _colors.COLORS.Control,
    backgroundIconIsOpen: _colors.COLORS.TextWhite,
    borderIconIsOpen: _colors.COLORS.TextWhite,
    radius: _borderRadius.BorderRadius.componentRadius,
    padding: '20px 24px',
    mobilePadding: '15px',
    storyColor: '#3D3D3D'
  }
};
var _default = themes;
exports["default"] = _default;